/** @jsx jsx */
import React from "react"
import { jsx } from "@emotion/react"
import ExternalLinkModal from "../components/ExternalLinkModal"

/**
 * Checks if a URL is external (not same origin as current site)
 */
export const isExternalLink = (href: string): boolean => {
  // Skip mailto, tel, etc.
  if (href.startsWith("mailto:") || href.startsWith("tel:") || href.startsWith("#")) {
    return false
  }

  try {
    const url = new URL(href, window.location.origin)
    return url.origin !== window.location.origin
  } catch {
    // If URL parsing fails, assume it's external
    return href.startsWith("http://") || href.startsWith("https://")
  }
}

/**
 * Wraps children with ExternalLinkModal if the href is external
 */
export const ExternalLink = ({
  href,
  children,
  className,
  ...props
}: {
  href: string
  children: React.ReactNode
  className?: string
  [key: string]: any
}) => {
  if (isExternalLink(href)) {
    return (
      <ExternalLinkModal href={href} className={className} {...props}>
        {children}
      </ExternalLinkModal>
    )
  }

  return (
    <a href={href} className={className} {...props}>
      {children}
    </a>
  )
}

export default ExternalLink
